import { useContext, useEffect, useRef, useState } from "react";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import UserContext from "src/provider/state-manager/userProvider";
import ApiContext from "src/provider/API/call-service";
import {
  AbsoluteContainer,
  AppLabel,
  AppSpan,
  AppText,
  Button,
  CustomContainer,
  FlexRow,
  Form,
  FormGroup,
  FormGroupWithIcon,
  GridContainer,
  ScreenTitle,
  UploadContainer,
} from "src/style";
//import UploadIcon from 'src/assets/svg/onboarding-upload-icon'
import { FiChevronDown } from "react-icons/fi";
import helpers from "src/utils/helpers";
import { handleTypeNumberControl, moneyFormat } from "src/utils/utility";
import {
  AppCenterPopupD3,
  AppCenterPopupPlusD3,
  CenterPopupHeaderD3,
  Portal,
} from "src/component";
import { ImNotification } from "react-icons/im";
import { RiDeleteBinLine } from "react-icons/ri";
import { billTypes, IDTypes } from "src/provider/config/constant";
import UploadIcon from "src/assets/svg/onboarding-upload-icon";
import PicIcon from "src/assets/svg/pics-icon";
import Webcam from "react-webcam";
import CameraIcon from "src/assets/svg/onboarding-camera-icon";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

export const AccountUpgradeD3: React.FC<any> = ({ close, verifyMe }) => {
  const { API } = useContext(ApiContext);
  const {
    user: { accountWithBalanceDetails, dashboardData, userInfo },
  } = useContext(UserContext);
  const { notifier } = useContext(VisibilityContext);
  const [input, setInput] = useState({
    currentTier: "",
    accountNumber: "",
    address: "",
    oldTier: "",
    bvn: helpers.validateBvn(userInfo?.profileInfo?.bvn) || "",
    nin: "",
    idType: "",
    idNumber: "",
    validIDBase64: "",
    validIDName: "",
    signatureBase64: "",
    signatureName: "",
    billType: "",
    utilityBase64: "",
    utilityName: "",
    validIDExtension: "",
    utilityExtension: "",
    signatureExtension: "",
    passportBase64: "",
    passportExtension: "",
    picture: "",
  });
  const [isPicture, setIsPicture] = useState(false);
  const [hover, setHover] = useState({
    validIDBase64: false,
    signatureBase64: false,
    utilityBase64: false,
    passportBase64: false,
  });

  const identificationImageRef = useRef<any>(null);
  const signatureRef = useRef<any>(null);
  const billImageRef = useRef<any>(null);
  const webcamRef = useRef<any>(null);
  const {
    info: { institutionData },
  } = useContext(AppInfoContext);

  useEffect(() => {
    if (accountWithBalanceDetails?.length === 1) {
      setInput({
        ...input,
        accountNumber: accountWithBalanceDetails[0].nuban,
      });

      let changeInfo: any = {
        target: {
          name: "accountNumber",
          value: accountWithBalanceDetails[0].nuban,
        },
      };

      handleInput(changeInfo);
    }
  }, [accountWithBalanceDetails]);

  const handleInput = async (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    let val = e.target.value;

    if (e.target.name === "accountNumber") {
      const currentTier = helpers.getAccountDetailsWithAcctNo(
        dashboardData,
        e.target.value
      )?.accountBalance?.accountTier;
      const defaultMessage =
        "Your account has already been upgraded to the latest tier";
      let response,
        isTier3 = Number(currentTier) === 3;

      if (!isTier3) {
        response = await API.getAccountUpgradeRequestStatus(val);
      }

      if (!verifyMe) {
        if (["PENDING", "COMPLETED"].includes(response?.status) || isTier3) {
          notifier.show(
            response?.status === "PENDING"
              ? "Your account upgrade request is still pending"
              : defaultMessage
          );
          close();
        } else if (response?.status === "REJECTED") {
          notifier.show(
            response.statusMessage ||
              "Your account upgrade request was reject. Kindly raise a new request"
          );
        }
      }
    }

    if (["bvn", "nin"].includes(e.target.name) && val.length > 11) return false;

    setInput({ ...input, [e.target.name]: val });
  };

  async function handleFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files instanceof FileList) {
      if (!helpers.isValidFileType(e.target.value)) {
        setInput({ ...input, [e.target.name]: "" });
        return notifier.show(
          "Only PNG, JPG and JPEG files are allowed",
          "Validation Error"
        );
      }

      let uploadedFile = await helpers.compressImage(e.target.files[0]);
      const extension = helpers.getFileExtension(e.target.value);

      if (!uploadedFile)
        return notifier.show("Unable to compress large file size uploaded");

      helpers
        .convertFileToBase64(uploadedFile)
        .then(async (result: any) => {
          setInput({
            ...input,
            [e.target.name]: result,
            [`${e.target.alt}Name`]: e.target.files![0]?.name,
            [`${e.target.alt}Extension`]: extension,
          });
        })
        .catch((err) => {
          notifier.show(JSON.stringify(err), "Validation Error");
        });
    }
  }

  async function handlePicture() {
    const pics = webcamRef.current.getScreenshot() as string;
    const extension = pics.split(";")[0]?.split("/")[1];

    // This below implemetation is basically to ensure file is compressed to fall to the expected maximum size
    let base64 = pics
      .replace("data:image/png;base64,", "")
      .replace("data:image/jpeg;base64,", "")
      .replace("data:image/jpg;base64,", "");
    let file = await helpers.ConvertBase64toFile(base64, "profile-pics");
    file = await helpers.compressImage(file);

    if (!file)
      return notifier.show("Unable to compress large size face captured");

    helpers.convertFileToBase64(file).then(async (result: any) => {
      setInput({
        ...input,
        picture: pics,
        passportBase64: result,
        passportExtension: extension,
      });
    });
  }

  const verifyPayload = {
    identificationType: input?.idType,
    identificationID: input?.idNumber,
    identificationImage: input?.passportBase64,
    otp: "",
    bvn: helpers.validateBvn(userInfo?.profileInfo?.bvn),
  };
  console.log("verifyPayload", verifyPayload);

  async function handleProceed(
    e: React.FormEvent<HTMLButtonElement | HTMLFormElement>
  ) {
    e.preventDefault();
    if (verifyMe) {
      const response = await API.verifyIdentity(verifyPayload);
      return;
    }
    if (input.bvn.length != 11 || !input.bvn.startsWith("22"))
      return notifier.show("Kindly provide a valid bvn", "Validation Response");

    await API.upgradeAccount(input);
    close();
  }

  return (
    <AppCenterPopupD3 height="80" zIndex="6" close={close} overflow="hidden">
      <CenterPopupHeaderD3
        title={!verifyMe ? "Upgrade Account" : "Verify Account"}
        close={close}
      />

      <CustomContainer
        height="85"
        style={{ maxHeight: "101%" }}
        className="popup-content-container"
      >
        <Form
          onSubmit={handleProceed}
          style={{ height: "90%" }}
          className="overflow-y-container"
        >
            {!verifyMe &&(
                <>
                 <FormGroupWithIcon>
            <label>Select Account</label>
            <div className="input-with-icon">
              <select
                name="accountNumber"
                value={input.accountNumber}
                style={{ color: input.accountNumber ? "#000000" : "#667085" }}
                onChange={handleInput}
                disabled={accountWithBalanceDetails?.length === 1}
                required={!verifyMe}
              >
                <option value="">Select Account</option>
                {accountWithBalanceDetails?.map((item: any, index: number) => {
                  return (
                    <option value={item.nuban} key={index}>
                      {item.nuban} - ({" "}
                      {moneyFormat(
                        item?.balance?.withdrawableAmount,
                        institutionData?.defaultCurrency
                      )}
                      )
                    </option>
                  );
                })}
              </select>
              <FiChevronDown className="input-with-icon-tag" />
            </div>
          </FormGroupWithIcon>
         
              <CustomContainer topMargin="2">
                <FormGroup>
                  <label>BVN</label>
                  <input
                    placeholder="Enter BVN"
                    name="bvn"
                    type="number"
                    value={input.bvn}
                    onChange={handleInput}
                    autoComplete="off"
                    disabled={!!helpers.validateBvn(userInfo?.profileInfo?.bvn)}
                    onKeyDown={handleTypeNumberControl}
                    onKeyUp={handleTypeNumberControl}
                    required={!verifyMe}
                  />
                </FormGroup>
                {!userInfo?.profileInfo?.bvn && (
                  <FlexRow
                    minHeight="4.8"
                    bgColor="#E7F6F5"
                    radius="0.8"
                    padding="1"
                    gap="1"
                    shadow="0px 1px 2px 0px #1018280D"
                  >
                    <AppSpan textSize="1.8" color="#0D968F">
                      <ImNotification />
                    </AppSpan>
                    <AppText textSize="1.2" color="#0A756F">
                      Dial *346# to get your 11 digits BVN on your registered
                      BVN line.
                    </AppText>
                  </FlexRow>
                )}
              </CustomContainer>
              <CustomContainer topMargin="2">
                <FormGroup>
                  <label>NIN</label>
                  <input
                    placeholder="Enter NIN"
                    name="nin"
                    type="number"
                    value={input.nin}
                    onChange={handleInput}
                    onKeyDown={handleTypeNumberControl}
                    onKeyUp={handleTypeNumberControl}
                    autoComplete="off"
                    required={!verifyMe}
                  />
                </FormGroup>
                <FlexRow
                  minHeight="4.8"
                  bgColor="#E7F6F5"
                  radius="0.8"
                  padding="1"
                  gap="1"
                  shadow="0px 1px 2px 0px #1018280D"
                >
                  <AppSpan textSize="1.8" color="#0D968F">
                    <ImNotification />
                  </AppSpan>
                  <AppText textSize="1.2" color="#0A756F">
                    Dial *565*0# to get your 11 digits NIN on your registered
                    NIN line.
                  </AppText>
                </FlexRow>
              </CustomContainer>
                </>
            )}
         
              <CustomContainer topMargin="2">
                <FlexRow gap="1.5" bottomMargin="2">
                  <AppText className="fixed-flex-item-shape">
                    ID Verification
                  </AppText>
                  <CustomContainer height="0.091" bgColor="#0D968F" />
                </FlexRow>

                <FormGroupWithIcon>
                  <label>Choose your identification type</label>
                  <div className="input-with-icon">
                    <select
                      placeholder="Select Type"
                      name="idType"
                      value={input.idType}
                      style={{ color: input.idType ? "#000000" : "#667085" }}
                      onChange={handleInput}
                      required
                    >
                      <option value="">Select Type</option>
                      {Object.entries(IDTypes)?.map(
                        ([value, idType], index) => {
                          return (
                            <option value={value} key={index}>
                              {idType}
                            </option>
                          );
                        }
                      )}
                    </select>
                    <FiChevronDown className="input-with-icon-tag" />
                  </div>
                </FormGroupWithIcon>
                <FormGroup>
                  <label>ID Number</label>
                  <input
                    placeholder="Enter ID Number"
                    name="idNumber"
                    value={input.idNumber}
                    onChange={handleInput}
                    autoComplete="off"
                    required
                  />
                </FormGroup>

                <CustomContainer topMargin="2">
                <FlexRow gap="1.5" bottomMargin="2">
                  <AppText className="fixed-flex-item-shape">
                    Photograph
                  </AppText>
                  <CustomContainer height="0.091" bgColor="#0D968F" />
                </FlexRow>
                {!isPicture && (
                  <UploadContainer
                    borderColor="#EAECF0"
                    radius="0.8"
                    minHeight="12.6"
                    padding="1.5"
                    hoverColor="#0D968F"
                    className="doc-upload-container"
                    onClick={() => setIsPicture(true)}
                    onMouseEnter={() =>
                      setHover({ ...hover, passportBase64: true })
                    }
                    onMouseLeave={() =>
                      setHover({ ...hover, passportBase64: false })
                    }
                  >
                    <CameraIcon
                      isHover={hover.passportBase64}
                      className="icon-component"
                    />
                    {/* <input type="file" name='picture' onChange={handleFile} className="file-input" id="picture" /> */}
                    <AppLabel
                      color="#0A756F"
                      fontWeight="600"
                      topMargin="1"
                      htmlFor="picture"
                    >
                      Click to take a Picture
                    </AppLabel>
                  </UploadContainer>
                )}
                {isPicture && (
                  <CustomContainer>
                    <CustomContainer
                      height="20"
                      radius="0.4"
                      overflow="hidden"
                      //style={{border: `4px dashed ${!input ? '#141B34' : '#6DE7B4' }`}}
                    >
                      {!input.passportBase64 ? (
                        <Webcam
                          audio={false}
                          screenshotFormat="image/jpeg"
                          className="faceScan-camera"
                          ref={webcamRef}
                          videoConstraints={{ facingMode: "user" }}
                          onUserMediaError={() =>
                            notifier.show("Camera not supported")
                          }
                        />
                      ) : (
                        <img src={input.picture} className="faceScan-camera" />
                      )}
                    </CustomContainer>
                    <GridContainer>
                      <Button
                        width={!input.passportBase64 ? "11" : "13"}
                        height="2.5"
                        borderColor="#0D968F"
                        hoverBgColor="#ffffff"
                        topMargin="2"
                        type="button"
                        titleSize="1.2"
                        radius="0.4"
                        hoverColor="#0D968F"
                        onClick={
                          !input.passportBase64
                            ? handlePicture
                            : () => setInput({ ...input, passportBase64: "" })
                        }
                      >
                        {!input.passportBase64
                          ? "Capture my face"
                          : "Re-capture my face"}
                      </Button>
                    </GridContainer>
                  </CustomContainer>
                )}
                {input.passportBase64 && (
                  <GridContainer
                    borderColor="#0D968F"
                    radius="0.8"
                    minHeight="9.6"
                    padding="1"
                    topMargin="2"
                  >
                    <FlexRow alignItems="flex-start">
                      <AbsoluteContainer top="0" right="0" zIndex="2">
                        <AppSpan
                          textSize="1.8"
                          color="#667085"
                          hoverColor="#F80000"
                          cursor="pointer"
                          onClick={() =>
                            setInput({
                              ...input,
                              passportBase64: "",
                              picture: "",
                            })
                          }
                        >
                          <RiDeleteBinLine />
                        </AppSpan>
                      </AbsoluteContainer>
                      <PicIcon
                        className="icon-component"
                        style={{
                          flexBasis: "auto",
                          flexShrink: "0",
                          flexGrow: "0",
                        }}
                      />
                      <CustomContainer leftMargin="1.5">
                        <AppLabel color="#344054" fontWeight="600">
                          Photo ID
                        </AppLabel>
                        <AppText color="#667085" topMargin="-0.7">
                          {helpers.getFileSize(input.passportBase64)} KB
                        </AppText>
                        <FlexRow gap="1">
                          <CustomContainer
                            width="85"
                            height="0.8"
                            sizeUnit="%"
                            bgColor="#EAECF0"
                            radius="0.4"
                            overflow="hidden"
                          >
                            <CustomContainer
                              bgColor="#0D968F"
                              height="0.8"
                              radius="0.4"
                              width="100"
                              sizeUnit="%"
                            />
                          </CustomContainer>
                          <AppSpan color="#344054" fontWeight="600">
                            100%
                          </AppSpan>
                        </FlexRow>
                      </CustomContainer>
                    </FlexRow>
                  </GridContainer>
                )}
              </CustomContainer>

                {!input.validIDBase64 && !verifyMe && (
                  <UploadContainer
                    borderColor="#EAECF0"
                    radius="0.8"
                    minHeight="12.6"
                    padding="1.5"
                    topMargin="2.5"
                    hoverColor="#0D968F"
                    className="doc-upload-container"
                    onClick={() => identificationImageRef.current.click()}
                    onMouseEnter={() =>
                      setHover({ ...hover, validIDBase64: true })
                    }
                    onMouseLeave={() =>
                      setHover({ ...hover, validIDBase64: false })
                    }
                  >
                    <UploadIcon
                      isHover={hover.validIDBase64}
                      className="icon-component"
                    />
                    <input
                      type="file"
                      name="validIDBase64"
                      onChange={handleFile}
                      ref={identificationImageRef}
                      className="file-input"
                      id="validIDBase64"
                      alt="validID"
                    />
                    <AppLabel
                      color="#0A756F"
                      fontWeight="600"
                      topMargin="1" //htmlFor='signatureBase64'
                    >
                      Click to upload a valid means of identification
                    </AppLabel>
                    <AppSpan color="#667085" textSize="1.2" topMargin="0.3">
                      PNG or JPG
                    </AppSpan>
                  </UploadContainer>
                )}

                {input.validIDBase64 && (
                  <GridContainer
                    borderColor="#0D968F"
                    radius="0.8"
                    minHeight="9.6"
                    padding="1"
                    topMargin="2"
                  >
                    <FlexRow alignItems="flex-start">
                      <AbsoluteContainer top="0" right="0" zIndex="2">
                        <AppSpan
                          textSize="1.8"
                          color="#667085"
                          hoverColor="#F80000"
                          cursor="pointer"
                          onClick={() =>
                            setInput({ ...input, validIDBase64: "" })
                          }
                        >
                          <RiDeleteBinLine />
                        </AppSpan>
                      </AbsoluteContainer>
                      <PicIcon
                        className="icon-component"
                        style={{
                          flexBasis: "auto",
                          flexShrink: "0",
                          flexGrow: "0",
                        }}
                      />
                      <CustomContainer leftMargin="1.5">
                        <AppLabel color="#344054" fontWeight="600">
                          {input.validIDName}
                        </AppLabel>
                        <AppText color="#667085" topMargin="-0.7">
                          {helpers.getFileSize(input.validIDBase64)} KB
                        </AppText>
                        <FlexRow gap="1">
                          <CustomContainer
                            width="85"
                            height="0.8"
                            sizeUnit="%"
                            bgColor="#EAECF0"
                            radius="0.4"
                            overflow="hidden"
                          >
                            <CustomContainer
                              bgColor="#0D968F"
                              height="0.8"
                              radius="0.4"
                              width="100"
                              sizeUnit="%"
                            />
                          </CustomContainer>
                          <AppSpan color="#344054" fontWeight="600">
                            100%
                          </AppSpan>
                        </FlexRow>
                      </CustomContainer>
                    </FlexRow>
                  </GridContainer>
                )}
              </CustomContainer>

              <CustomContainer topMargin="2">
                <FlexRow gap="1.5" bottomMargin="2">
                  <AppText className="fixed-flex-item-shape">Signature</AppText>
                  <CustomContainer height="0.091" bgColor="#0D968F" />
                </FlexRow>
                {!input.signatureBase64 ? (
                  <UploadContainer
                    borderColor="#EAECF0"
                    radius="0.8"
                    minHeight="12.6"
                    padding="1.5"
                    topMargin="2.5"
                    hoverColor="#0D968F"
                    className="doc-upload-container"
                    onClick={() => signatureRef.current.click()}
                    onMouseEnter={() =>
                      setHover({ ...hover, signatureBase64: true })
                    }
                    onMouseLeave={() =>
                      setHover({ ...hover, signatureBase64: false })
                    }
                  >
                    <UploadIcon
                      isHover={hover.signatureBase64}
                      className="icon-component"
                    />
                    <input
                      type="file"
                      name="signatureBase64"
                      onChange={handleFile}
                      ref={signatureRef}
                      className="file-input"
                      id="signatureBase64"
                      alt="signature"
                    />
                    <AppLabel
                      color="#0A756F"
                      fontWeight="600"
                      topMargin="1" //htmlFor='signatureBase64'
                    >
                      Click to upload Signature
                    </AppLabel>
                    <AppSpan color="#667085" textSize="1.2" topMargin="0.3">
                      PNG or JPG
                    </AppSpan>
                  </UploadContainer>
                ) : (
                  <GridContainer
                    borderColor="#0D968F"
                    radius="0.8"
                    minHeight="9.6"
                    padding="1"
                    topMargin="2"
                  >
                    <FlexRow alignItems="flex-start">
                      <AbsoluteContainer top="0" right="0" zIndex="2">
                        <AppSpan
                          textSize="1.8"
                          color="#667085"
                          hoverColor="#F80000"
                          cursor="pointer"
                          onClick={() =>
                            setInput({ ...input, signatureBase64: "" })
                          }
                        >
                          <RiDeleteBinLine />
                        </AppSpan>
                      </AbsoluteContainer>
                      <PicIcon
                        className="icon-component"
                        style={{
                          flexBasis: "auto",
                          flexShrink: "0",
                          flexGrow: "0",
                        }}
                      />
                      <CustomContainer leftMargin="1.5">
                        <AppLabel color="#344054" fontWeight="600">
                          {input.signatureName}
                        </AppLabel>
                        <AppText color="#667085" topMargin="-0.7">
                          {helpers.getFileSize(input.signatureBase64)} KB
                        </AppText>
                        <FlexRow gap="1">
                          <CustomContainer
                            width="85"
                            height="0.8"
                            sizeUnit="%"
                            bgColor="#EAECF0"
                            radius="0.4"
                            overflow="hidden"
                          >
                            <CustomContainer
                              bgColor="#0D968F"
                              height="0.8"
                              radius="0.4"
                              width="100"
                              sizeUnit="%"
                            />
                          </CustomContainer>
                          <AppSpan color="#344054" fontWeight="600">
                            100%
                          </AppSpan>
                        </FlexRow>
                      </CustomContainer>
                    </FlexRow>
                  </GridContainer>
                )}
              </CustomContainer>

              {!verifyMe && (
                <>
                 <CustomContainer topMargin="2">
                <FlexRow gap="1.5" bottomMargin="2">
                  <AppText className="fixed-flex-item-shape">
                    Address Verification
                  </AppText>
                  <CustomContainer height="0.091" bgColor="#0D968F" />
                </FlexRow>
                <FormGroup topMargin="2">
                  <label>Full Address</label>
                  <textarea
                    placeholder="Enter Address"
                    name="address"
                    value={input.address}
                    onChange={handleInput}
                    required={!verifyMe}
                  />
                </FormGroup>
           

                {!input.utilityBase64 && (
                  <UploadContainer
                    borderColor="#EAECF0"
                    radius="0.8"
                    minHeight="12.6"
                    padding="1.5"
                    topMargin="2.5"
                    hoverColor="#0D968F"
                    className="doc-upload-container"
                    onClick={() => billImageRef.current.click()}
                    onMouseEnter={() =>
                      setHover({ ...hover, utilityBase64: true })
                    }
                    onMouseLeave={() =>
                      setHover({ ...hover, utilityBase64: false })
                    }
                  >
                    <UploadIcon
                      isHover={hover.utilityBase64}
                      className="icon-component"
                    />
                    <input
                      type="file"
                      name="utilityBase64"
                      onChange={handleFile}
                      ref={billImageRef}
                      className="file-input"
                      id="utilityBase64"
                      alt="utility"
                    />
                    <AppLabel
                      color="#0A756F"
                      fontWeight="600"
                      topMargin="1" //htmlFor='utilityBase64'
                    >
                      Click to upload Utility Bills
                    </AppLabel>
                    <AppSpan color="#667085" textSize="1.2" topMargin="0.3">
                      PNG or JPG
                    </AppSpan>
                  </UploadContainer>
                )}
                {input.utilityBase64 && (
                  <GridContainer
                    borderColor="#0D968F"
                    radius="0.8"
                    minHeight="9.6"
                    padding="1"
                    topMargin="2"
                  >
                    <FlexRow alignItems="flex-start">
                      <AbsoluteContainer top="0" right="0" zIndex="2">
                        <AppSpan
                          textSize="1.8"
                          color="#667085"
                          hoverColor="#F80000"
                          cursor="pointer"
                          onClick={() =>
                            setInput({ ...input, utilityBase64: "" })
                          }
                        >
                          <RiDeleteBinLine />
                        </AppSpan>
                      </AbsoluteContainer>
                      <PicIcon
                        className="icon-component"
                        style={{
                          flexBasis: "auto",
                          flexShrink: "0",
                          flexGrow: "0",
                        }}
                      />
                      <CustomContainer leftMargin="1.5">
                        <AppLabel color="#344054" fontWeight="600">
                          {input.utilityName}
                        </AppLabel>
                        <AppText color="#667085" topMargin="-0.7">
                          {helpers.getFileSize(input.utilityBase64)} KB
                        </AppText>
                        <FlexRow gap="1">
                          <CustomContainer
                            width="85"
                            height="0.8"
                            sizeUnit="%"
                            bgColor="#EAECF0"
                            radius="0.4"
                            overflow="hidden"
                          >
                            <CustomContainer
                              bgColor="#0D968F"
                              height="0.8"
                              radius="0.4"
                              width="100"
                              sizeUnit="%"
                            />
                          </CustomContainer>
                          <AppSpan color="#344054" fontWeight="600">
                            100%
                          </AppSpan>
                        </FlexRow>
                      </CustomContainer>
                    </FlexRow>
                  </GridContainer>
                )}
              </CustomContainer>
                </>
          )}
          <CustomContainer topMargin="2.5">
            <Button
              width="100"
              sizeUnit="%"
              height="4.4"
              borderColor="#0D968F"
              hoverBgColor="#fff"
              hoverColor="#0D968F"
              titleSize="1.4"
            >
              {!verifyMe ? "Request Account Upgrade" : "Verify Account"}
              </Button>
          </CustomContainer>
        </Form>
      </CustomContainer>
      {/* </AppCenterPopupPlusD3> */}
      {/* </Portal> */}
    </AppCenterPopupD3>
  );
};

     {
       /* <FormGroupWithIcon>
                                        <label>Bill type</label>
                                        <div className="input-with-icon">
                                            <select 
                                                placeholder="Select Type"
                                                name='billType'
                                                value={input.billType}
                                                style={{color: input.billType ? '#000000' : '#667085'}}
                                                onChange={handleInput}
                                                required
                                            >
                                                <option value="">Select Type</option>
                                                {
                                                    Object.entries(billTypes)?.map(([value, billTypes], index) => {
                                                        return (
                                                            <option value={value} key={index}>
                                                                {billTypes}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon> */
     }
